import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index17() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="intro-section bg-lighter pt-3">
    <div className="container">
      <div className="banner-group">
        <div className="row">
          <div className="col-lg-5">
            <div className="banner banner-big banner-overlay">
              <a href="#">
                <img src="asset/images/demos/demo-17/banners/banner-1.jpg" alt="Banner" />
              </a>
              <div className="banner-content banner-content-bottom">
                <h4 className="banner-subtitle text-white"><a href="#">Trending now</a></h4>{/* End .banner-subtitle */}
                <h3 className="banner-title text-white"><a href="#">The Focus and Accent <br />On Your Spring Wardrobe</a></h3>{/* End .banner-title */}
                <a href="#" className="banner-link">Discover Now <i className="icon-long-arrow-right" /></a>
              </div>{/* End .banner-content */}
            </div>{/* End .banner */}
          </div>{/* End .col-lg-5 */}
          <div className="col-lg-7">
            <div className="banner banner-overlay">
              <a href="#">
                <img src="asset/images/demos/demo-17/banners/banner-2.jpg" alt="Banner" />
              </a>
              <div className="banner-content banner-content-right">
                <h4 className="banner-subtitle text-white"><a href="#">clearance</a></h4>{/* End .banner-subtitle */}
                <h3 className="banner-title text-white"><a href="#">Clearance It’s On <br />Up To 50% Off</a></h3>{/* End .banner-title */}
                <a href="#" className="banner-link">Shop Now <i className="icon-long-arrow-right" /></a>
              </div>{/* End .banner-content */}
            </div>{/* End .banner */}
            <div className="row">
              <div className="col-sm-6">
                <div className="banner banner-overlay">
                  <a href="#">
                    <img src="asset/images/demos/demo-17/banners/banner-3.jpg" alt="Banner" />
                  </a>
                  <div className="banner-content banner-content-top ">
                    <h4 className="banner-subtitle text-white"><a href="#">you might love</a></h4>{/* End .banner-subtitle */}
                    <h3 className="banner-title text-white"><a href="#">This Week's <br />Most Wanted</a></h3>{/* End .banner-title */}
                    <a href="#" className="banner-link">Shop Now <i className="icon-long-arrow-right" /></a>
                  </div>{/* End .banner-content */}
                </div>{/* End .banner */}
              </div>{/* End .col-sm-6 */}
              <div className="col-sm-6">
                <div className="banner banner-overlay">
                  <a href="#">
                    <img src="asset/images/demos/demo-17/banners/banner-4.jpg" alt="Banner" />
                  </a>
                  <div className="banner-content  banner-content-top banner-content-reverse">
                    <h4 className="banner-subtitle text-white"><a href="#">The new pretty</a></h4>{/* End .banner-subtitle */}
                    <h3 className="banner-title text-white"><a href="#">How To Dress<br />For Spring</a></h3>{/* End .banner-title */}
                    <a href="#" className="banner-link">Discover Now <i className="icon-long-arrow-right" /></a>
                  </div>{/* End .banner-content */}
                </div>{/* End .banner */}
              </div>{/* End .col-sm-6 */}
            </div>{/* End .row */}
          </div>{/* End .col-lg-7 */}
        </div>{/* End .row */}
      </div>{/* End .banner-group */}
    </div>{/* End .container */}
    <div className="icon-boxes-container">
      <div className="container">
        <div className="row">
          <div className="col-sm-6 col-lg-3">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-rocket" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Free Shipping</h3>{/* End .icon-box-title */}
                <p>Orders $50 or more</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-rotate-left" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Free Returns</h3>{/* End .icon-box-title */}
                <p>Within 30 days</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-info-circle" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Get 20% Off 1 Item</h3>{/* End .icon-box-title */}
                <p>When you sign up</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-life-ring" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">We Support</h3>{/* End .icon-box-title */}
                <p>24/7 amazing services</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-3 */}
        </div>{/* End .row */}
      </div>{/* End .container */}
    </div>{/* End .icon-boxes-container */}
  </div>{/* End .bg-lighter */}
  <div className="container">
    <h2 className="title text-center">Currently Popular Items</h2>{/* End .title */}
    <ul className="nav nav-pills nav-border-anim justify-content-center" role="tablist">
      <li className="nav-item">
        <a className="nav-link active" id="tab-new-link" data-toggle="tab" href="#tab-new" role="tab" aria-controls="tab-new" aria-selected="true">New</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" id="tab-featured-link" data-toggle="tab" href="#tab-featured" role="tab" aria-controls="tab-featured" aria-selected="false">Featured</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" id="tab-best-link" data-toggle="tab" href="#tab-best" role="tab" aria-controls="tab-best" aria-selected="false">Best Seller</a>
      </li>
    </ul>
    <div className="tab-content">
      <div className="tab-pane fade show active" id="tab-new" role="tabpanel" aria-labelledby="tab-new-link">
        <div className="row justify-content-center">
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Linen-blend dress</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $60.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#e5dcb1'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#bacbd8'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <span className="product-label label-primary">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-2.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shoes</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Sandals with lacing</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">Now $70.00</span>
                  <span className="old-price">Was $84.00</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-3.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Paper bag trousers</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $60.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#9fac76'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-7.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-7-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Handbags</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Paper straw shopper</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $398.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-4.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Handbags</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Bucket bag</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $350.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#e3a84d'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#f48a5b'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-5.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Silk-blend kaftan</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $370.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <span className="product-label label-new">New</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-6.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Linen-blend jumpsuit</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $595.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <span className="product-label label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-8.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shoes</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Sandals</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">Now $120.00</span>
                  <span className="old-price">Was $140.00</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
        </div>{/* End .row */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane fade" id="tab-featured" role="tabpanel" aria-labelledby="tab-featured-link">
        <div className="row justify-content-center">
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Linen-blend dress</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $60.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#e5dcb1'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#bacbd8'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-7.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-7-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Handbags</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Paper straw shopper</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $398.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <span className="product-label label-new">New</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-4.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Handbags</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Bucket bag</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $350.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#e3a84d'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#f48a5b'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-9.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Vest dress</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $9.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-3.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Paper bag trousers</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $60.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#9fac76'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <span className="product-label label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-8.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shoes</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Sandals</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">Now $120.00</span>
                  <span className="old-price">Was $140.00</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-5.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Silk-blend kaftan</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $370.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-6.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Linen-blend jumpsuit</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $595.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
        </div>{/* End .row */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane fade" id="tab-best" role="tabpanel" aria-labelledby="tab-best-link">
        <div className="row justify-content-center">
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-7.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-7-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Handbags</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Paper straw shopper</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $398.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-4.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Handbags</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Bucket bag</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $350.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#e3a84d'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#f48a5b'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-18/products/product-9.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-18/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Vest dress</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $9.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-3.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Paper bag trousers</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $60.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#9fac76'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <span className="product-label label-primary">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-2.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shoes</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Sandals with lacing</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">Now $70.00</span>
                  <span className="old-price">Was $84.00</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Linen-blend dress</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $60.00
                </div>{/* End .product-price */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#e5dcb1'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#bacbd8'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <span className="product-label label-new">New</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-6.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Clothing</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Linen-blend jumpsuit</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $595.00
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          <div className="col-6 col-md-4 col-lg-3">
            <div className="product product-4">
              <figure className="product-media">
                <span className="product-label label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-17/products/product-8.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-17/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                </div>{/* End .product-action */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shoes</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Sandals</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">Now $120.00</span>
                  <span className="old-price">Was $140.00</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
        </div>{/* End .row */}
      </div>{/* .End .tab-pane */}
    </div>{/* End .tab-content */}
    <div className="mb-3" />{/* End .mb-6 */}
  </div>{/* End .container */}
  <div className="cta bg-image bg-dark pt-4 pb-5" style={{backgroundImage: 'url(asset/images/demos/demo-17/bg-1.jpg)'}}>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-sm-10 col-md-8 col-lg-6">
          <div className="cta-heading text-center">
            <h3 className="cta-title text-white">Sign up for email &amp; get 25% off </h3>{/* End .cta-title */}
            <p className="cta-desc text-white">Subcribe to get information about products and coupons</p>{/* End .cta-desc */}
          </div>{/* End .text-center */}
          <form action="#">
            <div className="input-group">
              <input type="email" className="form-control" placeholder="Enter your Email Address" aria-label="Email Adress" required />
              <div className="input-group-append">
                <button className="btn btn-primary" type="submit"><span>Subscribe</span><i className="icon-long-arrow-right" /></button>
              </div>{/* .End .input-group-append */}
            </div>{/* .End .input-group */}
          </form>
        </div>{/* End .col-sm-10 col-md-8 col-lg-6 */}
      </div>{/* End .row */}
    </div>{/* End .container */}
  </div>{/* End .cta */}
  <div className="blog-posts">
    <div className="container">
      <div className="heading text-center">
        <h2 className="title">New Blog Posts</h2>{/* End .title */}
        <p className="title-desc">Donec nec justo eget felis facilisis fermentum.</p>{/* End .title-desc */}
      </div>{/* End .heading */}
      <div className="owl-carousel owl-simple mb-4" data-toggle="owl" data-owl-options="{
                      &quot;nav&quot;: false, 
                      &quot;dots&quot;: true,
                      &quot;items&quot;: 3,
                      &quot;margin&quot;: 20,
                      &quot;loop&quot;: false,
                      &quot;responsive&quot;: {
                          &quot;0&quot;: {
                              &quot;items&quot;:1
                          },
                          &quot;600&quot;: {
                              &quot;items&quot;:2
                          },
                          &quot;992&quot;: {
                              &quot;items&quot;:3
                          },
                          &quot;1200&quot;: {
                              &quot;items&quot;:3,
                              &quot;nav&quot;: true,
                              &quot;dots&quot;: false
                          }
                      }
                  }">
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-17/blog/post-1.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Sed adipiscing ornare.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-17/blog/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a><a>, 0 Comments
              </a></div>{/* End .entry-meta */}<a>
            </a><h3 className="entry-title"><a>
              </a><a href="single.html">Aenean dignissim pellentesque felis.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-17/blog/post-3.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Quisque volutpat mattis eros.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-17/blog/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Aenean dignissim pellentesque felis.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
      </div>{/* End .owl-carousel */}
      <div className="more-container text-center">
        <a href="blog.html" className="btn btn-outline-darker btn-more"><span>View more articles</span><i className="icon-long-arrow-right" /></a>
      </div>{/* End .more-container */}
      <hr className="mb-5" />
    </div>{/* End .container */}
  </div>{/* End .blog-posts */}
  <div className="container-fluid">
    <div className="heading text-center">
      <h2 className="title">Follow us on instagram</h2>{/* End .title */}
      <p className="title-desc">Donec nec justo eget felis facilisis fermentum.</p>{/* End .title-desc */}
    </div>{/* End .heading */}
    <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: false,
                  &quot;items&quot;: 5,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;360&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;600&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:5
                      }
                  }
              }">
      <div className="instagram-feed">
        <img src="asset/images/demos/demo-17/instagram/1.jpg" alt="img" />
        <div className="instagram-feed-content">
          <a href="#"><i className="icon-heart-o" />466</a>
          <a href="#"><i className="icon-comments" />65</a>
        </div>{/* End .instagram-feed-content */}
      </div>{/* End .instagram-feed */}
      <div className="instagram-feed">
        <img src="asset/images/demos/demo-17/instagram/2.jpg" alt="img" />
        <div className="instagram-feed-content">
          <a href="#"><i className="icon-heart-o" />39</a>
          <a href="#"><i className="icon-comments" />78</a>
        </div>{/* End .instagram-feed-content */}
      </div>{/* End .instagram-feed */}
      <div className="instagram-feed">
        <img src="asset/images/demos/demo-17/instagram/3.jpg" alt="img" />
        <div className="instagram-feed-content">
          <a href="#"><i className="icon-heart-o" />691</a>
          <a href="#"><i className="icon-comments" />87</a>
        </div>{/* End .instagram-feed-content */}
      </div>{/* End .instagram-feed */}
      <div className="instagram-feed">
        <img src="asset/images/demos/demo-17/instagram/4.jpg" alt="img" />
        <div className="instagram-feed-content">
          <a href="#"><i className="icon-heart-o" />508</a>
          <a href="#"><i className="icon-comments" />124</a>
        </div>{/* End .instagram-feed-content */}
      </div>{/* End .instagram-feed */}
      <div className="instagram-feed">
        <img src="asset/images/demos/demo-17/instagram/5.jpg" alt="img" />
        <div className="instagram-feed-content">
          <a href="#"><i className="icon-heart-o" />433</a>
          <a href="#"><i className="icon-comments" />27</a>
        </div>{/* End .instagram-feed-content */}
      </div>{/* End .instagram-feed */}
    </div>{/* End .owl-carousel */}
  </div>{/* End .container-fluid */}
</main>

        <UserFooter/>
    </div>
  )
}

export default Index17